<template>
  <div>
    <button class="btn btn-sm m-l-lg m-b-sm" type="button" @click="chartOpen()" >
      {{ isOpen ? 'Close' : 'Open' }}
    </button>
    <span class="m-l-lg lead"> {{ chartName }} </span>

    <transition name="expand">
      <div v-if="isOpen">
        <apexchart type=scatter :height="this.height" :options="this.chartOptions" :series="this.series"/>
        <apexchart v-if="showBrush" type=scatter :height="this.height/2" :options="this.brushOptions" :series="this.seriesBrush" />
      </div>
    </transition>
  </div>

</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue'
import { startCase, toLower } from 'lodash'

Vue.component('apexchart', VueApexCharts)
export default {
  props: {
    showBrush: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 240
    },
    uniqueName: {
      type: String,
      required: true
    },
    filterParams: {
      type: Object
    }
  },

  data () {
    return {
      autoScaleYaxis: false,
      isOpen: false,
      chartData: []
    }
  },

  methods: {
    chartOpen () {
      this.isOpen = !this.isOpen
      this.$http.get(`business_intelligence/${this.uniqueName}/data`, { params: this.filterParams }).then(response => {
        this.chartData = response.data[0].data
      })
    }
  },
  computed: {
    xaxisCategories () {
      return Object.keys(this.chartData).map((value) => {
        return [value]
      })
    },
    chartName () {
      return startCase(toLower(this.name))
    },
    series () {
      return [{
        name: startCase(toLower(this.name)),
        data: Object.keys(this.chartData).map((e) => {
          return this.chartData[e]
        })
      }]
    },

    seriesBrush () {
      return [
        { data: Object.keys(this.chartData).map((e) => {
          return this.chartData[e]
        }),
        name: this.name + 'Brush' }
      ]
    },

    chartOptions () {
      return {
        title: {
          text: startCase(toLower(this.name)),
          align: 'left'
        },
        chart: {
          zoom: {
            enabled: true
          },
          id: this.name,
          toolbar: {
            autoSelected: 'pan',
            show: true,
            export: {
              csv: {
                exportSelection: false
              }
            }
          },
          name: this.name,
          type: 'scatter'
        },
        xaxis: {
          categories: this.xaxisCategories
        },
        reversed: true
      }
    },

    brushOptions () {
      return {
        legend: {
          show: false
        },
        chart: {
          id: this.name + 'Brush',
          brush: {
            target: this.name,
            enabled: true,
            autoScaleYaxis: this.autoScaleYaxis
          },
          selection: {
            enabled: true,
            xaxis: {
              min: 1,
              max: this.chartData.length < 23 ? this.chartData.length : 23
            }
          },
          type: 'scatter'
        },
        xaxis: {
          tooltip: {
            enabled: false
          },
          labels: {
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        }
      }
    }
  }
}
</script>
